export default "__VITE_ASSET__219e2cbd__"